// Based on https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
// And https://react.dev/learn/removing-effect-dependencies#do-you-want-to-read-a-value-without-reacting-to-its-changes
// in eventually this hook is part of the core, we should remove this implementation
import { useCallback, useRef } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

export function useEffectEvent<Handler extends (...args: any[]) => any>(handler: Handler): Handler {
  const handlerRef = useRef<Handler>(undefined);

  // In a real implementation, this would run before layout effects
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  });

  return useCallback((...args: any[]) => {
    // In a real implementation, this would throw if called during render
    const fn = handlerRef.current!;

    return fn(...args);
  }, []) as Handler;
}
